import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { Link, useHistory } from "react-router-dom";

const Register = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */

  const [success, setSuccess] = useState(false)
  const register = async (formData) => {
    const valid = validateInput(formData);

    if(!valid)
      return;

    const data = {
      username: formData.username,
      password: formData.password
    }
    setShowButton(false)
    let put = await axios.post(`${config.endpoint}/auth/register`,data).then(res => {
      showSnack("Success", "success"); 
      setShowButton(true)
      console.log(res)
      userState("")
      passState("")
      confirmState("")
      setSuccess(true)
      history.push('/login')
    }).catch(err => {
      console.log(err.response)
      showSnack(err.response.data.message, "error"); 
      setShowButton(true)
    })

    return;
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  

  const [user, userState] = useState("")
  const [password, passState] = useState("")
  const [confirmPass, confirmState] = useState("")
  const [showButton, setShowButton] = useState(true)

  let validateInput = (data) => { 
    console.log(data.username, data.password, data.confirmPass)
    if(data.username.length === 0){
      showSnack("Username is a required field", "warning")
      return false;
    }

    if(data.username.length < 6){
      showSnack("Username must be at least 6 characters", "warning")
      return false;
    }

    if(data.password.length === 0){
      showSnack("Password is a required field", "warning")
      return false;
    }

    if(data.password.length < 6){
      showSnack("Password must be at least 6 characters", "warning")
      return false;
    }

    if(data.password !== data.confirmPass){
      showSnack("Passwords do not match", "error")
      return false;
    }

    return true;
  };

  const showSnack = (mess, color) => {
    enqueueSnackbar(mess, {
      autoHideDuration: 3000,
      variant: color
    })
  }
  return ( 
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            required
            fullWidth
            onChange={e => {
              userState(e.target.value)
            }}
            value={user}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            onChange={e => {
              passState(e.target.value)
            }}
            value={password}
            required
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            onChange={e => {
              confirmState(e.target.value)
            }}
            value={confirmPass}
            required
          />
           {showButton ? <Button className="button" variant="contained" role="button" onClick={(e) => register({username: user, password: password, confirmPass: confirmPass})}>
            Register
           </Button> : <CircularProgress /> }
          <p className="secondary-action">
            Already have an account?{" "}
             <Link className="link" to="/login">
              login here
             </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
